// extracted by mini-css-extract-plugin
export default {"image":"naa-z","loaded":"oaa-z","placeholder":"paa-z"};